import { userIsAdmin, validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { RoleEntity } from './role.entity';
import type { ValidationResult } from 'types';

export function validateRoleSelectAcl (): boolean {
    return validateAcls([ 'role_select' ]);
}

export function validateRoleUpdateAcl (): boolean {
    return validateAcls([ 'role_update' ]);
}

export function validateRole (role: RoleEntity): ValidationResult {
    if (role.contextId === null && !userIsAdmin()) {
        return {
            status: 'error',
            errorMessage: 'Cannot edit a core Argonaut Role',
        };
    }
    if (!role.name || (role.name && role.name.trim().length < 3)) {
        return {
            status: 'error',
            errorMessage: 'Role name must be at least 3 characters',
        };
    }
    return {
        status: 'success',
    };
}
